import { EnumUtils } from 'src/app/utils/enum-utils';
import { SectionColumnConfigCollectiveCannabinoidKey } from './section-column-config-collective-cannabinoid-key';
import { PrimaryCannabinoid } from './cannabinoid';

export const SectionColumnConfigCannabinoidKey = EnumUtils.createEnum([
  ...EnumUtils.getCannabinoids().filter(it => it !== PrimaryCannabinoid.THCAndCBD && it !== PrimaryCannabinoid.TAC),
  PrimaryCannabinoid.TAC,
  ...Object.values(SectionColumnConfigCollectiveCannabinoidKey)
]);
